import { atom } from 'jotai';

export namespace vl {
  export const currentModalAtom = atom<string | null>(null);
}
